// [claude-code 2026-04-18] Greeting chips now have explicit hover (gold tint + icon color lift)
//   and focus-visible ring for keyboard users. Chips already auto-dismiss the greeting by sending
//   a message (the thread store swaps to the messages list on first append), so no extra dismiss
//   handler needed — verified by reading FintheonThread.tsx:578 (greeting only renders when
//   messages.length === 0).
// [claude-code 2026-03-06] Extracted AnalysisGreeting from ChatInterface.
// [claude-code 2026-03-16] Shimmer greeting animation, removed border/bg/emoji from greeting area.
import { useState, useEffect } from "react";
import { useFintheonAgents } from "../../contexts/FintheonAgentContext";

function getGreeting(traderName?: string): string {
  const hour = new Date().getHours();
  if (hour < 12) return `Ave, ${traderName || "Trader"}. The markets stir.`;
  if (hour <= 17) return "The forum is active. What needs our attention?";
  return "The day's battles are done. What of the next conquest?";
}

interface ChatGreetingProps {
  onSend: (msg: string) => void;
  onSkillSend?: (skillId: string, msg: string) => void;
  isLoading: boolean;
}

export function ChatGreeting(_props: ChatGreetingProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Trigger animation on mount
    const t = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(t);
  }, []);

  let activeAgent: {
    name: string;
    icon: string;
    sector: string;
    description: string;
  } | null = null;
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const ctx = useFintheonAgents();
    activeAgent = ctx.activeAgent;
  } catch {
    // Provider not mounted yet — fallback
  }

  const agent = activeAgent || {
    name: "Harper",
    icon: "H",
    sector: "CAO",
    description: "Chief Analyst Officer — executive strategy and oversight",
  };
  const greeting = getGreeting();

  return (
    <div
      data-chat-greeting="composer-clear"
      className="mx-auto flex min-h-[clamp(220px,42vh,360px)] w-full max-w-[700px] flex-col items-center justify-end gap-3 px-5 pb-[clamp(32px,6vh,64px)] text-center"
    >
      <div className="flex flex-col items-center gap-2.5">
        <h2 className="text-[22px] font-semibold tracking-tight text-[var(--fintheon-text)]">
          {agent.name}
        </h2>
      </div>

      <h1
        className={[
          "max-w-[32ch] text-balance text-[clamp(22px,3vw,26px)] font-bold leading-snug tracking-tight",
          mounted ? "greeting-animate greeting-settle" : "opacity-0",
        ].join(" ")}
      >
        {greeting}
      </h1>
    </div>
  );
}
